import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
// Components
import Box from '../../shared/atoms/Box';
import Text from '../../shared/atoms/Text';
import Radio from '../../shared/atoms/Radio';
import Link from '../../shared/atoms/Link';
import Button from '../../shared/atoms/Button';

const CardContainer = styled(Box)`
  border: ${(p) =>
    p.selected
      ? `2px solid ${themeGet('colors.blue.electric')(p)}`
      : `1px solid ${themeGet('colors.gray.light')(p)}`};
  background: ${themeGet('colors.white')};
  transition: all 0.25s ease;
  ${(p) =>
    p.selectable &&
    css`
      cursor: pointer;
      &:hover {
        border-color: ${themeGet('colors.blue.electric')(p)};
      }
    `}
`;

const RadioBox = styled(Box)`
  width: 20px;
  height: 20px;
  position: relative;
`;

const formatLocation = (address) => {
  const parts = [
    address.postal_code,
    address.city,
    address.country && address.country !== 'FR' ? address.country : null,
  ].filter(Boolean);
  return parts.join(' ');
};

const BillingAddressCard = ({
  address,
  selectable = false,
  selected = false,
  onSelect = () => {},
  onSetDefault = () => {},
  onEdit = () => {},
  onDelete = () => {},
}) => {
  const { t } = useTranslation();
  return (
    <CardContainer
      borderRadius="xs"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      selectable={selectable}
      selected={selected}
      onClick={selectable ? () => onSelect(address) : undefined}
      p={4}
      mb={4}>
      <Box width="100%">
        <Box
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          width="100%">
          <Box>
            <Box flexDirection="row" alignItems="center" mb={1}>
              <Text fontWeight="bold" color="black" mr={2}>
                {address.billing_name}
              </Text>
              {address.is_default && (
                <Text variant="small" color="blue.electric" fontWeight="500">
                  {t('billingaddresses.card.default_badge')}
                </Text>
              )}
            </Box>
            {address.label ? (
              <Text variant="small" color="gray.dark">
                {address.label}
              </Text>
            ) : null}
            <Text variant="small" color="gray.darkest">
              {address.address_line1}
            </Text>
            <Text variant="small" color="gray.darkest">
              {formatLocation(address)}
            </Text>
          </Box>
          {selectable && <RadioBox>{selected && <Radio checked />}</RadioBox>}
        </Box>
        {!selectable && (
          <Box flexDirection="row" alignItems="center" mt={2}>
            {!address.is_default && (
              <Link
                color="blue.electric"
                mr={4}
                onClick={() => onSetDefault(address.id)}>
                {t('billingaddresses.card.set_default')}
              </Link>
            )}
            <Button
              variant="neutral"
              color="primary.darkest"
              mr={2}
              onClick={() => onEdit(address)}>
              {t('billingaddresses.actions.edit')}
            </Button>
            <Button
              variant="neutral"
              color="primary.darkest"
              onClick={() => onDelete(address.id)}>
              {t('billingaddresses.actions.delete')}
            </Button>
          </Box>
        )}
      </Box>
    </CardContainer>
  );
};

export default BillingAddressCard;
